import { createStructuredSelector, createSelector } from 'reselect';
import { mfcSelector } from '@selectors/mfcSelector';

import { servicesCatalogSelector } from '@selectors/servicesCatalogSelector';

const officesSelector = (state) => state.filters.offices;
const showFullCatalogSelector = (state, props) => props.showFullCatalog;

const officeSelector = createSelector(
  officesSelector,
  mfcSelector,
  showFullCatalogSelector,
  (offices, office, showFullCatalog) => {
    const officeId = !showFullCatalog && Number(office?.id);
    if (!officeId) {
      return null;
    }
    const { id, bookableServicesIds } = offices.find(
      (oneOffice) => oneOffice.id === officeId
    );

    return {
      id,
      bookableServicesIds,
    };
  }
);

const catalogSelector = createSelector(
  // @ts-ignore
  servicesCatalogSelector,
  officeSelector,
  showFullCatalogSelector,
  (fullCatalog) => fullCatalog
);

export const serviceCatalogSelector = createStructuredSelector({
  catalog: catalogSelector,
  office: officeSelector,
});

export type ServiceCatalogSelectorProps = {
  catalog: any;
  office: any;
};
